import React from 'react';
import { Modal, COLORS, formatCurrency } from './InventoryUIKit';
import InvoiceTable from './InvoiceTable';

/**
 * BatchBreakdownModal
 *
 * Reusable modal that shows the FIFO purchase-batch breakdown behind a
 * cost figure. Used by:
 *  - CampInvoice  -> "View Detailed Cost Breakdown" (aggregate across items)
 *  - BagInvoice   -> "View Batch Breakdown" (per inventory item, per row)
 *
 * Column shape differs slightly between the two callers, so columns are
 * passed in rather than hard-coded here.
 *
 * @param {string} title
 * @param {string} [subtitle]
 * @param {Array} columns - InvoiceTable column config
 * @param {Array} rows
 * @param {number} grandTotal
 * @param {boolean} [loading]
 * @param {string} [error]
 * @param {() => void} [onRetry]
 * @param {() => void} onClose
 */
const BatchBreakdownModal = ({
  title = 'FIFO Batch Breakdown',
  subtitle,
  columns,
  rows,
  grandTotal,
  loading,
  error,
  onRetry,
  onClose,
}) => {
  const footer = (
    <tr style={{ borderTop: `2px solid ${COLORS.mediumGrey}` }}>
      <td colSpan={Math.max(1, columns.length - 1)} style={{ padding: '10px 12px', fontWeight: '700', color: COLORS.darkText, textAlign: 'right' }}>
        Grand Total
      </td>
      <td style={{ padding: '10px 12px', fontWeight: '700', color: COLORS.darkText, textAlign: 'right' }}>
        {formatCurrency(grandTotal)}
      </td>
    </tr>
  );

  return (
    <Modal title={title} subtitle={subtitle} onClose={onClose} width="720px">
      <InvoiceTable
        columns={columns}
        rows={rows}
        loading={loading}
        error={error}
        onRetry={onRetry}
        emptyMessage="No batch consumption found for this selection."
        footer={typeof grandTotal === 'number' ? footer : null}
        rowKey="key"
      />
    </Modal>
  );
};

export default BatchBreakdownModal;
